function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.191 7.846a.693.693 0 000 .956.637.637 0 00.924 0l3.694-3.824a.693.693 0 000-.956L1.115.198a.637.637 0 00-.924 0 .693.693 0 000 .956L3.424 4.5.19 7.846z",
  fill: "#F58221",
  fillRule: "evenodd"
});

function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowForward;